import { render, staticRenderFns } from "./Tasks.vue?vue&type=template&id=665555b8&scoped=true&"
import script from "./Tasks.vue?vue&type=script&setup=true&lang=js&"
export * from "./Tasks.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665555b8",
  null
  
)

export default component.exports